type Params = {
  label: string;
  claim?: string;
  route?: string;
  icon?: string;
  subitems?: Params[];
  parent?: MenuItem | null;
  externalLink?: boolean | null;
};

export class MenuItem {
  public label: string;
  public route: string;
  public claim: string;
  public icon: string;
  public opened: boolean = false;
  public active: boolean = false;
  public subitems?: MenuItem[] = null;
  public readonly parent: MenuItem | null;
  public externalLink: boolean = false;

  constructor(params: Params) {
    this.route = params?.route || null;
    this.icon = params?.icon || null;
    this.label = params?.label || null;
    this.claim = params?.claim || null;
    this.externalLink = params?.externalLink;
    if (params?.subitems?.length) {
      this.subitems = params.subitems.map((x) => new MenuItem({ ...x, parent: this }));
    }
    this.parent = params?.parent || null;

  }

  addSubitem(...subitems: MenuItem[]) {
    this.subitems.push(...subitems);
  }
}
/*
export const menuItems: MenuItem[] = [
  new MenuItem({
    label: 'Sistema',
    icon: 'web',
    subitems: [
      {
        label: 'Administração',
        subitems: [
          { label: 'Rotinas', route: null },
          { label: 'Submenus', route: null },
          { label: 'Usuários', route: null },
          { label: 'Acessos', route: null },
        ],
      },
    ],
  }),
  new MenuItem({
    label: 'Cadastro',
    icon: 'edit',
    subitems: [
      {
        label: 'Empresas',
        subitems: [{ label: 'Cadastro de Empresas', route: '/cadastro/empresas' }],
      },
      {
        label: 'Regras de Distribuição',
        subitems: [
          { label: 'Listagem de Regras', route: '/cadastro/regras-de-distribuicao' },
          { label: 'Cadastro de Regras', route: '/cadastro/regras-de-distribuicao/novo' }
        ],
      },
      {
        label: 'Vistoria',
        subitems: [
          { label: 'Listagem de Vistoria', route: '/cadastro/vistoria' },
          { label: 'Cadastro de Vistoria', route: '/cadastro/vistoria/novo' }
        ],
      },
      {
        label: 'Peças',
        subitems: [{ label: 'Cesta Básica', route: null }],
      },
      {
        label: 'Procedimentos',
      },
      {
        label: 'Traduçoes',
      },
    ],
  }),
  new MenuItem({ label: 'Parâmetros', icon: 'list' }),
  new MenuItem({ label: 'Portal Prestadores', icon: 'group' }),
  new MenuItem({ label: 'Operações', icon: 'build' }),
  new MenuItem({ label: 'Relatórios', icon: 'assignment' }),
  new MenuItem({ label: 'Financeiro', icon: 'attach_money' }),
  new MenuItem({ label: 'Regulação Digital', icon: 'menu_book' }),
];*/


export const menuItems: MenuItem[] = [
  new MenuItem(
    {
    label: 'Menu',
    icon: 'menu',
    subitems: [
      {
        label: 'Empresas',
        claim: 'company',
        subitems: [{ label: 'Cadastro de Empresas', claim: 'company', route: '/cadastro/empresas' }],
      },
      {
        label: 'Regras de Distribuição',
        claim: 'distributionRules',
        subitems: [
          { label: 'Listagem de Regras', claim: 'distributionRules', route: '/cadastro/regras-de-distribuicao' },
          { label: 'Cadastro de Regras', claim: 'distributionRules', route: '/cadastro/regras-de-distribuicao/novo' },
          { label: 'Listagem de Regras (exceção)', claim: 'distributionRules', route: '/cadastro/regras-de-distribuicao-excecao' },
          { label: 'Cadastro de Regras (exceção)', claim: 'distributionRules', route: '/cadastro/regras-de-distribuicao-excecao/novo' }
        ],
      },
      {
        label: 'Vistoria',
        claim: 'inspection',
        subitems: [
          { label: 'Cadastro de Vistoria', claim: 'inspection', route: '/cadastro/vistoria/handler' },
          { label: 'Consulta de Vistoria Agendada', claim: 'inspection', route: '/cadastro/vistoria/agendamento/lista' },
          { label: 'Fila de Agendamento', claim: 'inspection', route: '/handle' },
          { label: 'Listagem de Vistoria', claim: 'inspection', route: '/cadastro/vistoria' },          
          { label: 'Dashboard Balcão Virtual', claim: 'inspection', route: '/balcao' }
        ],
      },
      {
        label: 'Dashboard',
        claim: 'company',
        route: '/cadastro/vistoria',
        externalLink: true
      },
      {
        label: 'Workflow',
        claim: 'company',
        route: '/cadastro/vistoria',
        externalLink: true
      }
    ]
  }
)
];

export const menuItemsMaster: MenuItem[] = [
  new MenuItem({
    label: 'Menu',
    icon: 'menu',
    subitems: [
      {
        label: 'Empresas',
        claim: 'company',
        subitems: [{ label: 'Cadastro de Empresas', claim: 'company', route: '/cadastro/empresas' }],
      },
      {
        label: 'Regras de Distribuição',
        claim: 'distributionRules',
        subitems: [
          { label: 'Listagem de Regras', claim: 'distributionRules', route: '/cadastro/regras-de-distribuicao' },
          { label: 'Cadastro de Regras', claim: 'distributionRules', route: '/cadastro/regras-de-distribuicao/novo' },
          { label: 'Listagem de Regras (exceção)', claim: 'distributionRules', route: '/cadastro/regras-de-distribuicao-excecao' },
          { label: 'Cadastro de Regras (exceção)', claim: 'distributionRules', route: '/cadastro/regras-de-distribuicao-excecao/novo' }
        ],
      },
      {
        label: 'Vistoria',
        claim: 'inspection',
        subitems: [
          { label: 'Cadastro de Vistoria', claim: 'inspection', route: '/cadastro/vistoria/handler' },
          { label: 'Consulta de Vistoria Agendada', claim: 'inspection', route: '/cadastro/vistoria/agendamento/lista' },
          { label: 'Fila de Agendamento', claim: 'inspection', route: '/handle' },
          { label: 'Listagem de Vistoria', claim: 'inspection', route: '/cadastro/vistoria' },
          { label: 'Relatório', claim: 'inspection', route: '/relatorio' },             
          { label: 'Dashboard Balcão Virtual', claim: 'inspection', route: '/balcao' }
        ],
      },
      {
        label: 'Administração',
        claim: 'admdev',
        subitems: [
          { label: 'Cadastro Manual de Vistoria', claim: 'admdev', route: '/cadastro/administracao/cadastro-manual-vistoria' },
          { label: 'Status de Vistoria', claim: 'admdev', route: '/cadastro/administracao/status-vistoria' },
          { label: 'Grupo de Imagens', claim: 'admdev', route: '/cadastro/administracao/grupo-imagens' },
          { label: 'Histórico', claim: 'admdev', route: '/cadastro/administracao/historico' },
          { label: 'Cadastro de Restrições', claim: 'admdev', route: '/cadastro/administracao/cadastro-restricoes' }
        ],
      },
      {
        label: 'Dashboard',
        claim: 'company',
        route: '/cadastro/vistoria',
        externalLink: true
      },
      {
        label: 'Workflow',
        claim: 'company',
        route: '/cadastro/vistoria',
        externalLink: true
      }
    ]
  })
];

export const menuItemsBroker: MenuItem[] = [
  new MenuItem({
    label: 'Cadastro',
    icon: 'edit',
    subitems: [
      {
        label: 'Empresas',
        claim: 'company',
        subitems: [{ label: 'Cadastro de Empresas', claim: 'company', route: '/cadastro/empresas' }],
      },
      {
        label: 'Vistoria',
        claim: 'inspection',
        subitems: [
          { label: 'Listagem de Vistoria', claim: 'inspection', route: '/cadastro/vistoria' },             
          { label: 'Dashboard Balcão Virtual', claim: 'inspection', route: '/balcao' }
        ],
      }
    ]
  })
];

export const menuItemsMasterDev: MenuItem[] = [
  new MenuItem({
    label: 'Menu',
    icon: 'menu',
    subitems: [
      {
        label: 'Empresas',
        claim: 'company',
        subitems: [{ label: 'Cadastro de Empresas', claim: 'company', route: '/cadastro/empresas' }],
      },
      {
        label: 'Regras de Distribuição',
        claim: 'distributionRules',
        subitems: [
          { label: 'Listagem de Regras', claim: 'distributionRules', route: '/cadastro/regras-de-distribuicao' },
          { label: 'Cadastro de Regras', claim: 'distributionRules', route: '/cadastro/regras-de-distribuicao/novo' },
          { label: 'Listagem de Regras (exceção)', claim: 'distributionRules', route: '/cadastro/regras-de-distribuicao-excecao' },
          { label: 'Cadastro de Regras (exceção)', claim: 'distributionRules', route: '/cadastro/regras-de-distribuicao-excecao/novo' }
        ],
      },
      {
        label: 'Vistoria',
        claim: 'inspection',
        subitems: [
          { label: 'Listagem de Vistoria', claim: 'inspection', route: '/cadastro/vistoria' },
          { label: 'Consulta de Vistoria Agendada', claim: 'inspection', route: '/cadastro/vistoria/agendamento/lista' },
          { label: 'Cadastro de Vistoria', claim: 'inspection', route: '/cadastro/vistoria/handler' },
          { label: 'Relatório', claim: 'inspection', route: '/relatorio' },   
          { label: 'Dashboard Balcão Virtual', claim: 'inspection', route: '/balcao' }
        ],
      },
      {
        label: 'Administração',
        claim: 'admdev',
        subitems: [
          { label: 'Cadastro Manual de Vistoria', claim: 'admdev', route: '/cadastro/administracao/cadastro-manual-vistoria' },
          { label: 'Status de Vistoria', claim: 'admdev', route: '/cadastro/administracao/status-vistoria' },
          { label: 'Grupo de Imagens', claim: 'admdev', route: '/cadastro/administracao/grupo-imagens' },
          { label: 'Histórico', claim: 'admdev', route: '/cadastro/administracao/historico' },
          { label: 'Cadastro de Restrições', claim: 'admdev', route: '/cadastro/administracao/cadastro-restricoes' }
        ],
      },
      {
        label: 'Suporte',
        claim: 'inspection',
        subitems: [
          { label: 'Consultar cep (distribuição)', claim: 'inspection', route: '/suporte-tecnico/cep-distribuicao' },
          { label: 'Excluir usuário', claim: 'inspection', route: '/suporte-tecnico/remover-usuario' },
          { label: 'Exportar regiões de atendimento', claim: 'inspection', route: '/suporte-tecnico/atendimento-regioes' },
          { label: 'Importar Código Corretor', claim: 'inspection', route: '/suporte-tecnico/codigo-corretor' },
          { label: 'Liberar reenvio do laudo', claim: 'inspection', route: '/suporte-tecnico/liberar-reenvio' },
        ],
      },
      {
        label: 'Dashboard',
        claim: 'company',
        route: '/cadastro/vistoria',
        externalLink: true
      },
      {
        label: 'Workflow',
        claim: 'company',
        route: '/cadastro/vistoria',
        externalLink: true
      }
    ]
  })
];